import React from 'react'

import {
  LntButton,
  LntDivider,
  LntForm,
  LntFormGroup,
  LntFormItem,
  LntInput,
  LntInputNumber,
  LntSelect
} from '@app/components/base'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getTypes } from '@app/api/routes/monitorings'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getStores } from '@app/api/routes/locationStores'

import { getHierarchyKey } from './utils'
import { hierarchySelectOptions } from './config'

import styles from './styles.module.scss'

import type { CommonQuotaFormProps } from './types'
import type { ProductsFormData } from '../types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle
}

export const CommonQuotaForm: React.FC<CommonQuotaFormProps> = ({ dataSource, isEditForm, onSubmit, onClose }) => {
  const defaultSelectValues = {
    monitoringType: isEditForm && dataSource?.monitoringType ? [dataSource.monitoringType] : undefined,
    store: isEditForm && dataSource?.store ? [dataSource.store] : undefined,
    cluster: isEditForm && dataSource?.cluster ? [dataSource.cluster] : undefined,
    clustersGroup: isEditForm && dataSource?.clustersGroup ? [dataSource.clustersGroup] : undefined
  }

  const buttonText = isEditForm ? 'Сохранить' : 'Добавить'

  const hierarchyValues =
    dataSource?.trend ??
    dataSource?.purchasingGroup ??
    dataSource?.commodityGroup ??
    dataSource?.category ??
    dataSource?.subcategory

  return (
    <LntForm<ProductsFormData>
      onSubmit={ onSubmit }
      layout='vertical'
    >
      <div className={ styles.commonQuotaForm__itemsWrapper }>
        <LntFormItem
          name='monitoringTypeIds'
          label='Область применения'
          defaultValue={ defaultSelectValues.monitoringType }
          validationOptions={ { rules: { required: !isEditForm && 'Выберите хотя бы один тип' } } }
        >
          <LntSelect
            { ...commonSelectProps }
            disabled={ isEditForm }
            placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
            querySelect={ {
              queryKey: [MONITORINGS_TYPES_KEY.typesItems],
              queryFn: getTypes,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='storeIds'
          defaultValue={ defaultSelectValues.store }
        >
          <LntSelect
            { ...commonSelectProps }
            disabled={ isEditForm }
            placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationStoresItems],
              queryFn: getStores,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='clusterIds'
          defaultValue={ defaultSelectValues.cluster }
        >
          <LntSelect
            { ...commonSelectProps }
            disabled={ isEditForm }
            placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClustersItems],
              queryFn: getClusters,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='clustersGroupIds'
          defaultValue={ defaultSelectValues.clustersGroup }
        >
          <LntSelect
            { ...commonSelectProps }
            disabled={ isEditForm }
            placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClusterGroupsItems],
              queryFn: getClusterGroups,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormGroup
          label='Товарная иерархия'
          className={ styles.commonQuotaForm__inputs }
        >
          <div className={ styles.commonQuotaForm__inputs }>
            <LntFormItem
              className={ styles.commonQuotaForm__inputsItem }
              name='hierarchyKey'
              defaultValue={ isEditForm ? getHierarchyKey() : [] }
            >
              <LntSelect
                disabled={ isEditForm }
                placeholder={ FILTERS_PLACEHOLDERS.hierarchyLevel }
                options={ hierarchySelectOptions }
                showArrow
              />
            </LntFormItem>

            <LntFormItem
              className={ styles.commonQuotaForm__inputsItem }
              name='hierarchyValues'
              defaultValue={ hierarchyValues }
            >
              <LntInput
                disabled={ isEditForm }
                placeholder={ FILTERS_PLACEHOLDERS.value }
              />
            </LntFormItem>
          </div>
        </LntFormGroup>

        <LntDivider className={ styles.commonQuotaForm__line } />

        <LntFormItem
          name='brandCount'
          label='Квота Бренд'
          defaultValue={ dataSource?.brandCount }
        >
          <LntInputNumber
            className={ styles.commonQuotaForm__itemFullSize }
            placeholder='Введите значение'
            size={ SIZE.middle }
            min={ 0 }
          />
        </LntFormItem>

        <LntFormItem
          name='eppCount'
          label='Квота EPP/ЧТМ'
          defaultValue={ dataSource?.eppCount }
        >
          <LntInputNumber
            className={ styles.commonQuotaForm__itemFullSize }
            placeholder='Введите значение'
            size={ SIZE.middle }
            min={ 0 }
          />
        </LntFormItem>

        <div className={ styles.commonQuotaForm__buttons }>
          <LntButton
            onClick={ onClose }
            type={ BUTTON_TYPE.secondary }
            size={ SIZE.middle }
          >
            Отменить
          </LntButton>
          <LntButton
            htmlType='submit'
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
          >
            { buttonText }
          </LntButton>
        </div>
      </div>
    </LntForm>
  )
}
